import React, { Suspense } from "react";
import { Route, Router, Redirect, Switch } from "react-router-dom";
import Routers from "./routes";
import * as Layout from "../layout";
import { history } from "../helpers";
import CodeSplitter from "helpers/CodeSplitter";
import Modal, { PageLoader } from "component/Common/LoaderModal";
import { NotificationContainer } from "react-notifications";

function Routes() {
  return (
    <Router history={history}>
      <Switch>
        <Suspense fallback={<PageLoader />}>
          {Routers.map(
            ({
              component,
              name,
              componentPath = "",
              redirect,
              path,
              exact = false,
              auth = true,
              childrens = [],
            }) => {
              if (childrens.length > 0) {
                return (
                  <Suspense key={path} fallback={<PageLoader />}>
                    <Route
                      path={path}
                      exact={exact}
                      render={(props) => {
                        if (redirect && props.location.pathname === path) {
                          return <Redirect to={redirect} />;
                        }
                        const LayoutComponent = Layout[component];
                        return (
                          <LayoutComponent {...props}>
                            <Suspense
                              fallback={
                                <div style={{ height: "80vh" }}>
                                  <PageLoader loading={true} />
                                </div>
                              }
                            >
                              {childrens.map(
                                ({
                                  component: ChildrenComponent,
                                  componentPath: childComponentPath,
                                  name = "",
                                  path: childrenPath,
                                  exact = false,
                                  auth = true,
                                }) => {
                                  CodeSplitter.addComponent(childComponentPath, name);

                                  return (
                                    <Route
                                      path={path + childrenPath}
                                      exact={exact}
                                      key={path + childrenPath}
                                      render={(props) => {
                                        let PageComponent = CodeSplitter.getComponent(name);

                                        if (auth && localStorage.getItem("user_token")) {
                                          return (
                                            <>
                                              <PageComponent {...props} />
                                              <Modal loading={true} />
                                            </>
                                          );
                                        } else if (auth && !localStorage.getItem("user_token")) {
                                          let redirectUrl;

                                          if (props.location.pathname.includes("/portal/dashboard"))
                                            redirectUrl = "/auth/login";
                                          else
                                            redirectUrl = `/auth/login?redirect=${encodeURIComponent(
                                              `${path}${childrenPath}${props.location.search}`
                                            )}`;

                                          return <Redirect to={`${redirectUrl}`} />;
                                        } else {
                                          return (
                                            <>
                                              <PageComponent {...props} />
                                              <Modal loading={true} />
                                            </>
                                          );
                                        }
                                      }}
                                    />
                                  );
                                }
                              )}
                            </Suspense>
                          </LayoutComponent>
                        );
                      }}
                    />
                  </Suspense>
                );
              }

              CodeSplitter.addComponent(componentPath, name);
              return (
                <Suspense key={component || 2322} fallback={<PageLoader />}>
                  <Route
                    path={path}
                    exact={exact}
                    render={(props) => {
                      if (component) {
                        let PageComponent = CodeSplitter.getComponent(name);
                        return (
                          <div>
                            <PageComponent />
                            <Modal loading={true} />
                          </div>
                        );
                      }

                      if (redirect) {
                        if (props.location.pathname === path) {
                          return <Redirect to={redirect} />;
                          // return null;
                        }
                      }
                      return null;
                    }}
                  />
                </Suspense>
              );
            }
          )}
        </Suspense>
      </Switch>
      <NotificationContainer />
    </Router>
  );
}

export default React.memo(Routes);
